import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CHECK_REPORTING_PASSWORD_SET, GET_REPORTING_PASSWORD } from '../../config';
import { SetReportPasswordRequiredDialogComponent } from '../components/set-report-password-required-dialog/set-report-password-required-dialog.component';

@Injectable()
export class ReportingPasswordService {
  private readonly _reportingPasswordSet = new BehaviorSubject<boolean>(false);
  private readonly _reportingPasswordBypass = new BehaviorSubject<boolean>(false);
  
  readonly reportingPasswordSet$: Observable<boolean> = this._reportingPasswordSet.asObservable();
  readonly reportingPasswordBypass$: Observable<boolean> = this._reportingPasswordBypass.asObservable();

  readonly reportingPasswordBypassNorSet$: Observable<boolean> = combineLatest([
    this._reportingPasswordSet,
    this._reportingPasswordBypass,
  ]).pipe(map(([set, bypass]) => !(set || bypass)));

  constructor(
    private readonly apiService: ApiService,
    private readonly dialog: MatDialog
  ) {}

  /**
   * Fetches whether the user has set a report password and updates the observable state.
   * Call once after token is available, and again after user sets/changes the password.
   */
  checkReportingPasswordSet(): void {
    this.apiService.get(CHECK_REPORTING_PASSWORD_SET).subscribe(
      (result) => {
        this._reportingPasswordSet.next(result?.data?.status === true);
        this._reportingPasswordBypass.next(result?.data?.bypass_active === true);
      },
      () => {
        this._reportingPasswordSet.next(false);
        this._reportingPasswordBypass.next(false);
      }
    );
  }

  /**
   * Fetches the reporting password from the API.
   * @returns Observable that emits the password string or null on error/missing data.
   */
  getReportingPassword(): Observable<string | null> {
    return this.apiService.get(GET_REPORTING_PASSWORD).pipe(
      map((result) =>
        result?.status === 'success' ? (result?.data?.password ?? null) : null
      ),
      catchError(() => of(null))
    );
  }

  

  openSetPasswordRequiredDialog(): void {
    this.dialog.open(SetReportPasswordRequiredDialogComponent, {
      width: '684px',
      maxWidth: '684px',
      autoFocus: false,
      disableClose: false,
    });
  }
}
